module.exports = __webpack_public_path__ + "media/complete.908421c0.mp3";